<template>
    <div>
      <form v-on:submit.prevent="addChatGPT">
        <div class="row">
            <div class="col-md-12">
                <label for="">Behavior</label>
                <textarea v-model="form.trained_prompt" class="form-control" rows="20"></textarea>
                <br>
            </div>
        </div>
        <br>
        <div class="button-group d-flex pt-25">
            <button type="submit" class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
              Simpan
            </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>

  export default {
    props: ['form', 'id'],
    data() {
      return {
        device: []
        // form: {
        //     device: [],
        //     name: "",
        //     api_key: "",
        //     models: "gpt-4o-mini",
        //     enable_memory: false,
        //     max_token_chat: 128,
        //     max_token_number: 1024,
        //     max_token_day: 102400,
        //     temperature: 0.5,
        //     top_p: 0.5,
        //     disable_during_office_hour: false,
        //     fallback_message: "",
        //     reenable_ai_duration: 15,
        //     custom_prompt: "",
        // },
      };
    },
    mounted() {
        // this.form.daily_max_token_number = this.form.daily_max_token_number
        // this.form.daily_max_token_global = this.form.daily_max_token_global
        this.form.enable_memory = this.form.enable_memory == 1 ? true : false
        this.form.disable_during_office_hour = this.form.disable_during_office_hour == 1 ? true : false
 
        this.getDevice()
    },
    methods: {
        async getDevice(param) {
                let res = await this.$store.dispatch("device_list_all", param);
                this.device = res.data.data.devices

                let d = this.device.find(x => x.id == this.form.device_id)
                this.form.device = d     
            },
            async addChatGPT() {
              try {
                  // Salin form agar mudah dimanipulasi
                  let request = { ...this.form };
                  let old_device = this.form.device;

                  // Modifikasi request dengan data yang diperlukan
                  request.id = this.id;
                  request.device = request.device?.id || null; // Pastikan ada fallback jika device.id tidak ada
                  request.enable_memory = request.enable_memory ? 1 : 0;
                  request.disable_during_office_hour = request.disable_during_office_hour ? 1 : 0;

                  // Pastikan parsing data aman
                  request.max_token_chat = parseInt(request.max_token_chat) || 0;
                  request.daily_max_token_number = parseInt(request.daily_max_token_number) || 0;
                  request.daily_max_token_global = parseInt(request.daily_max_token_global) || 0;
                  request.reenable_ai_duration = parseInt(request.reenable_ai_duration) || 0;
                  request.temperature = parseFloat(request.temperature) || 0.0;
                  request.top_p = parseFloat(request.top_p) || 0.0;

                  // Kirim request melalui Vuex action
                  let response = await this.$store.dispatch('chatgpt_update', request);

                  // Tampilkan pesan sukses
                  this.$toast.success(response.data.message);

                  // Kembalikan form.device ke nilai awal
                  this.form.device = old_device;

                  // Jika diperlukan, aktifkan event berikut
                  // this.$root.$emit("toggle_modal", "new_bot");
                  // this.$root.$emit("refresh_table", true);
              } catch (err) {
                  // Tangani error dan tampilkan pesan
                  const errorMessage = err.response?.data?.message || 'Something went wrong';
                  this.$toast.error(errorMessage);
              }
        }
    },
  };
  </script>
  
